import React from 'react';
import { Search, GitCompare, ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';

const STEPS = [
  {
    icon: Search,
    title: 'Recherchez',
    description: 'Trouvez le produit dentaire dont vous avez besoin parmi plus de 6 000 références.',
    accent: 'from-emerald-50 to-white',
  },
  {
    icon: GitCompare,
    title: 'Comparez',
    description: 'Visualisez en un coup d\'œil les prix de tous les fournisseurs algériens, leur stock et leur fraîcheur.',
    accent: 'from-amber-50 to-white',
  },
  {
    icon: ShoppingCart,
    title: 'Économisez',
    description: 'Commandez au meilleur prix directement auprès du fournisseur de votre choix. Paiement à la livraison.',
    accent: 'from-rose-50 to-white',
  },
];

const HowItWorks = () => {
  return (
    <section className="bg-[#FAF7F2] py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="text-xs uppercase tracking-[0.2em] text-[#C75B27] font-semibold mb-2">Comment ça marche</div>
          <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">3 étapes pour économiser sur vos achats dentaires</h2>
          <p className="text-[#7A6F5C] mt-3">
            Comptoir-Online centralise les offres de dizaines de fournisseurs algériens pour vous garantir le meilleur prix sur chaque produit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 relative">
          {STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div key={idx} className={`relative bg-gradient-to-br ${s.accent} border border-[#E8E0D0] rounded-2xl p-6 lg:p-8`}>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-[#1F4D3F] text-white flex items-center justify-center shadow-sm">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="text-5xl font-serif font-bold text-[#1F4D3F]/15 leading-none">0{idx + 1}</div>
                </div>
                <h3 className="font-serif text-2xl font-semibold text-[#1F4D3F]">{s.title}</h3>
                <p className="mt-2 text-[#5A5247] text-sm leading-relaxed">{s.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <Link to="/categories" className="inline-flex items-center gap-2 bg-[#1F4D3F] hover:bg-[#173B30] text-white px-8 py-3 rounded-lg font-medium">
            Commencer à comparer maintenant
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
